<template>
  <v-container fluid pa-0>
    <h1 class="headline">Other Contents</h1>
    <contents owner-name="OTHER" owner-id="0" />
  </v-container>
</template>

<script>
import Contents from "../../../gt/shared/contents/Contents";
export default {
  name: "OtherContents",
  components: {
    Contents
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/contents/OtherContents.vue